define(['./is-number'], function(isNumber) {
    'use strict';
    return function(value, maximumFractionDigits) {
        if (isNumber(value) && isNumber(maximumFractionDigits)) {
            return parseFloat(value.toFixed(maximumFractionDigits)) === 0;
        }
        return false;
    };
});
